import { useTheme } from '@mui/material';
import React, { SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {
  color?: React.CSSProperties['color'];
}

const GraphBarIcon: React.FC<Props> = ({ width = 22, height = 12, color, ...props }) => {
  const theme = useTheme();
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 22 12"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 12H2V3C2 2.44772 1.55228 2 1 2C0.447715 2 0 2.44771 0 3V12Z"
        fill={color || theme.palette.secondary.main}
      />
      <path
        d="M4 12H6V5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5V12Z"
        fill={color || theme.palette.secondary.main}
      />
      <path
        d="M12 5C12 4.44772 12.4477 4 13 4C13.5523 4 14 4.44772 14 5V12H12V5Z"
        fill={color || theme.palette.secondary.main}
      />
      <path
        d="M16 3C16 2.44772 16.4477 2 17 2C17.5523 2 18 2.44772 18 3V12H16V3Z"
        fill={color || theme.palette.secondary.main}
      />
      <path
        d="M20 1C20 0.447715 20.4477 0 21 0C21.5523 0 22 0.447715 22 1V12H20V1Z"
        fill={color || theme.palette.secondary.main}
      />
      <path
        d="M8 12H10V7C10 6.44772 9.55228 6 9 6C8.44772 6 8 6.44772 8 7V12Z"
        fill={color || theme.palette.secondary.main}
      />
    </svg>
  );
};

export default GraphBarIcon;
